<ng-content *ngIf="!phxLoading"></ng-content>
<div class="phx-summary-skeleton" *ngIf="phxLoading">
    <div class="phx-summary phx-summary-skeleton-box">
        <phx-skeleton phxWidth="80px" phxHeight="24px"></phx-skeleton>
        <phx-skeleton phxWidth="60px" phxHeight="16px"></phx-skeleton>
    </div>
    <div class="phx-summary phx-summary-skeleton-box">
        <phx-skeleton phxWidth="80px" phxHeight="24px"></phx-skeleton>
        <phx-skeleton phxWidth="60px" phxHeight="16px"></phx-skeleton>
    </div>
</div>
